import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import palette from '../../styles/palette';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';

const DATE_FORMAT = 'MM/DD/YYYY';
const KEY_DATE_FORMAT = 'MMM DD YYYY';
dayjs.extend(isBetweenPlugin);

const KeyDates = ({ selectedDates }) => {
  const collisionPoint = useMediaQuery('(max-width:667px)');
  const smValue = collisionPoint ? 12 : 6;

  const styles = {
    keyDatesGrid: {
      display: 'flex',
    },
    keyDatesBox: {
      border: 1,
      borderColor: palette.gt_teal_6,
      backgroundColor: palette.gt_teal_2,
      padding: '3vh',
      width: '100%',
      minHeight: { xs: '38vh', sm: '30vh' },
    },
    typography: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  };

  return (
    <>
      <Grid item xs={12} sm={smValue} lg={6} sx={styles.keyDatesGrid}>
        <Box sx={styles.keyDatesBox}>
          <Stack direction="column" spacing={2}>
            <Typography variant="h5">
              <strong>Key Dates</strong>
            </Typography>
            <Divider />
            <Typography>
              <strong>Selected campaign dates:</strong>
            </Typography>
            {selectedDates ? (
              <Typography data-testid="selectedDates">
                {[
                  dayjs(selectedDates.start).format(DATE_FORMAT),
                  dayjs(selectedDates.end).format(DATE_FORMAT),
                ].join(' to ')}
              </Typography>
            ) : (
              <Typography variant="body1">
                <strong>___</strong>
              </Typography>
            )}
            <Divider />
            <Grid container>
              <Grid item xs={7.5}>
                <Typography>
                  <strong>Last day to purchase:</strong>
                </Typography>
              </Grid>
              <Grid item xs={4.5}>
                {selectedDates ? (
                  <Typography sx={styles.typography}>
                    {dayjs(selectedDates.closeDate).format(KEY_DATE_FORMAT)}
                  </Typography>
                ) : (
                  <Typography sx={styles.typography}>
                    <strong>___</strong>
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Divider />
            <Grid container>
              <Grid item xs={6}>
                <Typography>
                  <strong>Materials due:</strong>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {selectedDates ? (
                  <Typography sx={styles.typography}>
                    {dayjs(selectedDates.dueDate).format(KEY_DATE_FORMAT)}
                  </Typography>
                ) : (
                  <Typography sx={styles.typography}>
                    <strong>___</strong>
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Divider />
          </Stack>
        </Box>
      </Grid>
    </>
  );
};

export default KeyDates;
